import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMyArticles, createMyArticle, updateMyArticle } from '../../api/pro';
import { PageHeader } from '../../components/layout/PageHeader';
import { useProEntry } from '../../contexts/ProEntryContext';
import { ArticleFields } from '../../components/ArticleFields';
export default function ProArticleForm() {
    const { id } = useParams();
    const isEdit = !!id;
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { activeEntryId } = useProEntry();
    const [form, setForm] = useState({
        title: '', content: '', excerpt: '', image_url: '', published_at: '', end_at: '',
        links: [],
        practical_info: [],
        secondary_images: [],
    });
    // Pro has no single-article endpoint — hydrate from the (content-rich) list.
    const { data: list } = useQuery({
        queryKey: ['my-articles', activeEntryId],
        queryFn: () => getMyArticles(activeEntryId),
        enabled: isEdit && activeEntryId != null,
    });
    useEffect(() => {
        const found = list?.data.find((a) => a.id === Number(id));
        if (found)
            setForm({
                title: found.title, content: found.content, excerpt: found.excerpt ?? '', image_url: found.image_url ?? '',
                published_at: found.published_at?.slice(0, 16) ?? '', end_at: found.end_at?.slice(0, 16) ?? '',
                links: found.links ?? [], practical_info: found.practical_info ?? [],
                secondary_images: found.secondary_images ?? [],
            });
    }, [list, id]);
    const saveMut = useMutation({
        mutationFn: () => {
            const body = {
                title: form.title, content: form.content, excerpt: form.excerpt || null, image_url: form.image_url || null,
                published_at: form.published_at || null, end_at: form.end_at || null,
                links: form.links, practical_info: form.practical_info,
                secondary_images: form.secondary_images,
            };
            return isEdit ? updateMyArticle(Number(id), body) : createMyArticle(activeEntryId, body);
        },
        onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['my-articles'] }); navigate('/pro/articles'); },
    });
    const handleSubmit = (e) => { e.preventDefault(); saveMut.mutate(); };
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: isEdit ? 'Modifier l\'actualité' : 'Nouvelle actualité' }), _jsxs("form", { onSubmit: handleSubmit, className: "bg-white rounded-lg border border-gray-200 p-6 space-y-4 max-w-3xl", children: [_jsx(ArticleFields, { value: form, onChange: (patch) => setForm((f) => ({ ...f, ...patch })) }), _jsxs("div", { className: "flex gap-3 pt-2", children: [_jsx("button", { type: "submit", disabled: saveMut.isPending || (!isEdit && !activeEntryId), className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50", children: saveMut.isPending ? 'Enregistrement...' : 'Enregistrer' }), _jsx("button", { type: "button", onClick: () => navigate('/pro/articles'), className: "px-4 py-2 border rounded-lg text-sm hover:bg-gray-50", children: "Annuler" })] })] })] }));
}
